var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00504 7.19035C11.0014 7.19035 12.6198 5.58073 12.6198 3.59517C12.6198 1.60961 11.0014 0 9.00504 0C7.00865 0 5.39026 1.60961 5.39026 3.59517C5.39026 5.58073 7.00865 7.19035 9.00504 7.19035Z",
    fill: "#83BA26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9576 15.5072C17.5827 13.8092 16.7229 12.255 15.4815 11.0312C15.1802 10.7305 14.8537 10.4558 14.5055 10.2103C12.9199 9.02733 10.9871 8.3957 9.00503 8.41269C6.5814 8.40035 4.25118 9.3416 2.52253 11.0312C1.28115 12.255 0.421364 13.8092 0.0464032 15.5072C-0.0187708 15.8074 -0.0152502 16.1184 0.0567045 16.4171C0.128659 16.7158 0.267207 16.9946 0.462103 17.2328C0.663942 17.4762 0.918111 17.6715 1.20589 17.8042C1.49366 17.937 1.80771 18.0038 2.1249 17.9998H15.8852C16.2033 18 16.5174 17.929 16.8042 17.7921C17.091 17.6552 17.3431 17.4559 17.5419 17.2089C17.7333 16.9734 17.8699 16.6987 17.9418 16.4044C18.0136 16.1102 18.0191 15.8037 17.9576 15.5072Z",
    fill: "#83BA26"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.ee3f0ce2f336b4a59b26a951a8804954.svg";
export { ForwardRef as ReactComponent };